import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/contexts/AuthContext';
import { Loader2 } from 'lucide-react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

/**
 * AuthCallback - Handles OAuth callback from Emergent Auth
 * Processes session_id from URL fragment and exchanges it for a session token
 */
const AuthCallback = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { setUserFromOAuth } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processOAuthCallback = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = location.hash;
        const sessionIdMatch = hash.match(/session_id=([^&]+)/);
        
        if (!sessionIdMatch) {
          console.error('No session_id found in callback URL');
          navigate('/login', { replace: true });
          return;
        }

        const sessionId = sessionIdMatch[1];

        // Exchange session_id for user data via backend
        const response = await axios.post(`${API}/api/auth/oauth/session`, {
          session_id: sessionId
        });

        const { user, access_token } = response.data;

        // Store token and set user
        localStorage.setItem('token', access_token);
        setUserFromOAuth(user, access_token);

        // Check if user needs onboarding
        if (!user.onboarding_completed) {
          navigate('/onboarding', { replace: true, state: { user } });
        } else {
          navigate('/dashboard', { replace: true, state: { user } });
        }
      } catch (error) {
        console.error('OAuth callback error:', error);
        navigate('/login', { replace: true });
      }
    };

    processOAuthCallback();
  }, [location, navigate, setUserFromOAuth]);

  return (
    <div className="min-h-screen bg-dark-bg flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-vocalira animate-spin mx-auto mb-4" />
        <p className="text-dark-muted">Entrando na sua conta...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
